import { Machine } from "xstate";
import { ClockWorkModule } from "@/store/modules/clockWork.module";
import { ClockWorkEntryModel } from "@/store/models/clockWork/clockWorkEntry";
function getFormattedDateString(value) {
    return `${value.getFullYear()}-${value.getMonth() + 1}-${value.getDate()}T00:00:00`;
}
function clockWorkNeedsFix() {
    return ClockWorkModule.longRunningEntry;
}
function HasLiveEntryToday() {
    return ClockWorkModule.cwMiniEntry != null;
}
function DoesNotHasLiveEntryToday() {
    return !HasLiveEntryToday();
}
function hasCWMiniEntries() {
    return ClockWorkModule.cwMiniEntry != null;
}
// function cwMiniLoaded(): boolean {
// 	return ClockWorkModule.cwMiniLoaded;
// }
// function cwMiniNotLoaded(): boolean {
// 	return !ClockWorkModule.cwMiniLoaded;
// }
const clockWorkMiniMachine = Machine({
    id: "ClockWorkMini",
    context: {
        currentDate: undefined,
    },
    initial: "idle",
    states: {
        idle: {
            // always: [
            // 	{
            // 		target: "gettingMiniStatus",
            // 		cond: "cwMiniNotLoaded",
            // 	},
            // 	{
            // 		target: "processMiniStatus",
            // 		cond: "cwMiniLoaded",
            // 	},
            // ],
            always: [
                {
                    target: "gettingMiniStatus",
                },
            ],
        },
        gettingMiniStatus: {
            invoke: {
                id: "gettingMiniStatus",
                src: (context, event) => {
                    return ClockWorkModule.GetClockWorkMini(getFormattedDateString(context.currentDate));
                },
                onDone: { target: "processMiniStatus" },
                onError: { target: "serviceUnavailable" },
            },
            exit: () => { },
        },
        processMiniStatus: {
            entry: () => {
                //console.log("entering processMiniStatus");
            },
            always: [
                {
                    target: "needsFix",
                    cond: "clockWorkNeedsFix",
                },
                {
                    target: "running",
                    cond: "HasLiveEntryToday",
                },
                {
                    target: "stopped",
                    cond: "DoesNotHasLiveEntryToday",
                },
            ],
        },
        needsFix: {},
        starting: {
            entry: [
                (_, __) => {
                    console.log("Starting: " + new Date().toISOString().substr(11, 8));
                },
                "clearLiveTimer",
            ],
            invoke: {
                id: "liveEntryAddition",
                src: (context, event) => {
                    let liveEntry = new ClockWorkEntryModel();
                    liveEntry.startTime = new Date();
                    return ClockWorkModule.AddCwMiniEntry(liveEntry);
                },
                onDone: { target: "running" },
                onError: { target: "serviceUnavailable" },
            },
        },
        running: {
            on: {
                STOP: { target: "stopping" },
                START: { target: "starting" },
            },
        },
        stopping: {
            invoke: {
                id: "liveEntryStopping",
                src: (context, event) => {
                    return ClockWorkModule.EndCwMiniEntry(event.liveEntry);
                },
                onDone: { target: "stopped" },
                onError: { target: "serviceUnavailable" },
            },
            exit: ["clearLiveTimer", "clearDescription"],
        },
        stopped: {
            on: {
                START: { target: "starting" },
                RUNNING_STATE: { target: "running" },
            },
        },
        serviceUnavailable: { type: "final" },
    },
}, {
    guards: {
        clockWorkNeedsFix,
        HasLiveEntryToday,
        DoesNotHasLiveEntryToday,
    },
    actions: {
        clearLiveTimer: () => {
            ClockWorkModule.ResetLiveTimer();
        },
        clearDescription: () => {
            ClockWorkModule.cwMiniEntry.description = "";
        },
    },
});
export default clockWorkMiniMachine;
